// Вот ваш мок‑массив, но с добавленным флагом isActive
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { prodMock } from 'entities/vitrinsFilters/config/consts';
import type { IVitrinsFiltersState } from 'entities/vitrinsFilters/types';

const initialState: IVitrinsFiltersState = prodMock;

/**
 * TODO: Доработать в рамках https://sravni-corp.atlassian.net/browse/CF-3559
 */
export const vitrinsFiltersSlice = createSlice({
  name: 'vitrinsFilters',
  initialState,
  reducers: {
    toggleFilter(state, { payload }: PayloadAction<{ alias: string; value: string }>) {
      const { alias, value } = payload;
      const filter = state.find((f) => f.alias === alias);

      if (!filter) {
        throw new Error('not found filter by alias');
      }

      if (filter.selectedValue === value) {
        filter.selectedValue = null;
        return;
      }

      filter.selectedValue = value;
    },
  },
});

export const { toggleFilter } = vitrinsFiltersSlice.actions;
